import { render } from "./EditArrivalDeclarationPage.vue?vue&type=template&id=e4f01dc6"
import script from "./EditArrivalDeclarationPage.vue?vue&type=script&lang=js"
export * from "./EditArrivalDeclarationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__